module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"days":"Open days","additionalBeds":"Additional beds","unitsSold":"Number of units sold","status":"Report status"},"sl":{"days":"Odprto dni","additionalBeds":"Število dodatnih ležišč","unitsSold":"Število prodanih namestitvenih enot","status":"Status poročila"}}')
  delete Component.options._Ctor
}
